const PENDING_CLAIM_PREFIX = 'spt_mandatory_claim_pending:';

/**
 * Persists "this steamId was gated into the mandatory-claim modal and left
 * without submitting an email" across page loads/tab closes, so returning to
 * the same profile re-opens the gate even after the background sync has
 * finished (isSynced alone can't tell new-and-unclaimed from returning,
 * since it flips true on its own schedule regardless of claim status).
 *
 * @param {string} steamId Profile the gate armed on.
 * @returns {boolean} True while that profile still owes an address.
 */
export function isMandatoryClaimPending(steamId) {
  if (!steamId || typeof window === 'undefined' || !window.localStorage) return false;
  try {
    return window.localStorage.getItem(PENDING_CLAIM_PREFIX + steamId) === '1';
  } catch (_) {
    return false;
  }
}

/**
 * Sets or clears that flag.
 *
 * @param {string} steamId Profile the gate armed on.
 * @param {boolean} pending True to arm, false to clear once an address is sent.
 * @returns {void}
 */
export function setMandatoryClaimPending(steamId, pending) {
  if (!steamId || typeof window === 'undefined' || !window.localStorage) return;
  try {
    if (pending) {
      window.localStorage.setItem(PENDING_CLAIM_PREFIX + steamId, '1');
    } else {
      window.localStorage.removeItem(PENDING_CLAIM_PREFIX + steamId);
    }
  } catch (_) { /* storage unavailable (private mode etc) — gate just won't persist */ }
}
